import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.map.get-or-insert.js";
import "core-js/modules/esnext.map.get-or-insert-computed.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import AIQuizGenerationTextField from "@/components/aiQuizGenerator/AIQuizGenerationTextField.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { DOC2SPEACH_ALLOWED_DOCS_EXTENSIONS } from "@/util/fileUtil";
let AIQuizGenerationDocumentUpload = class AIQuizGenerationDocumentUpload extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "disabled", void 0);
    _defineProperty(this, "failedDocs", void 0);
    _defineProperty(this, "documents", []);
  }
  get acceptedDocTypes() {
    return DOC2SPEACH_ALLOWED_DOCS_EXTENSIONS;
  }
  onFileUpload() {
    // remove eventual duplicates
    this.documents = Array.from(new Map(this.documents.map(doc => [`${doc.name}-${doc.size}`, doc])).values());
    this.emitDocumentUploadData();
  }
  handleRemove() {
    this.$nextTick(() => {
      this.emitDocumentUploadData();
    });
  }
  onFailedDocs() {
    this.documents.forEach(doc => {
      doc.status = this.failedDocs?.includes(doc.raw?.name || '') ? 'fail' : 'success';
    });
  }
  emitDocumentUploadData() {
    return this.documents.map(doc => doc.raw);
  }
};
__decorate([Prop({
  default: false
})], AIQuizGenerationDocumentUpload.prototype, "disabled", void 0);
__decorate([Prop({
  default: []
})], AIQuizGenerationDocumentUpload.prototype, "failedDocs", void 0);
__decorate([Watch("failedDocs")], AIQuizGenerationDocumentUpload.prototype, "onFailedDocs", null);
__decorate([Emit('dataChange')], AIQuizGenerationDocumentUpload.prototype, "emitDocumentUploadData", null);
AIQuizGenerationDocumentUpload = __decorate([Component({
  components: {
    StandardButton,
    AIQuizGenerationTextField,
    WInput
  }
})], AIQuizGenerationDocumentUpload);
export default AIQuizGenerationDocumentUpload;